module.exports = __webpack_public_path__ + "img/lg_ring_0_0_0_null@3x.00964d55.png";